var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgF2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "#EECAFF",
    rx: 25
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E28DFF",
    d: "M15.607 15.894L21.07 15v18.17l-5.12.67c-.93.122-1.795-.445-1.933-1.267a1.333 1.333 0 0 1-.018-.22V17.6c0-.836.676-1.554 1.607-1.707z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC5FCF",
    d: "M21.071 15l7.072.786v18.071l-7.072-.694z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E28DFF",
    d: "M28.143 15.771l5.046-.75c.945-.14 1.84.416 2 1.242.017.084.025.169.025.254v15.009c0 .74-.61 1.372-1.444 1.495l-5.627.836V15.771z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC5FCF",
    d: "M32.464 37c-2.357-2.035-3.535-3.716-3.535-5.042 0-1.989 1.583-3.6 3.535-3.6 1.953 0 3.536 1.611 3.536 3.6 0 1.326-1.179 3.007-3.536 5.042zm0-3.457c.977 0 1.768-.774 1.768-1.729 0-.954-.791-1.728-1.768-1.728-.976 0-1.768.774-1.768 1.728 0 .955.792 1.729 1.768 1.729z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgF2);
export default __webpack_public_path__ + "static/media/f2.569bd7ef331e4f3a01d08df02ce837f2.svg";
export { ForwardRef as ReactComponent };